export default __webpack_public_path__ + "static/media/headerImg1.78ef0fae.jpg";